export interface MenuRowBounds {
  /** Distance from the top of the menu's scrollable content. */
  top: number;
  height: number;
}

/** Dividers are list rows too; anything shorter than this is not an option a user would read as cut. */
const MIN_OPTION_ROW_HEIGHT = 16;

/**
 * Height for a menu that may not fit: the full content when it fits, otherwise a height that cuts the last visible
 * option through its middle, so the half-shown row makes it obvious the menu scrolls.
 */
export const getHalfCutMenuHeight = (rows: MenuRowBounds[], contentHeight: number, availableHeight: number): number => {
  if (contentHeight <= availableHeight) {
    return contentHeight;
  }
  const optionMidpoints = rows
    .filter((row) => {
      return row.height >= MIN_OPTION_ROW_HEIGHT;
    })
    .map((row) => {
      return row.top + row.height / 2;
    })
    .filter((midpoint) => {
      return midpoint <= availableHeight;
    });
  return optionMidpoints.length ? Math.max(...optionMidpoints) : availableHeight;
};
